
    import Vue from "vue";
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";

    @Component
    export default class DetailsLayout extends Vue {
        @Prop({default: true})
        addContainerCss!: boolean;

        get cssClass(){
            return this.addContainerCss ? 'container' : '';
        }
    }
